import { HandleSSOCallback } from "@clerk/tanstack-react-start";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

import { DEFAULT_POST_AUTH_REDIRECT, validateAuthRedirectSearch } from "@/lib/auth-routing";
import { authorizeRequestFromSearch } from "@/lib/connect-partner";
import { seoHead } from "@/lib/seo";

export const Route = createFileRoute("/login/sso-callback/")({
  validateSearch: validateAuthRedirectSearch,
  head: () =>
    seoHead({
      title: "Signing in - Bavimail",
      description: "Completing sign-in.",
      path: "/login/sso-callback/",
      noindex: true,
    }),
  component: SsoCallbackRoute,
});

// Where the connect flow's provider hop returns when Clerk still has work to do: a new user's
// sign-up to finish (legal consent, on /login/complete), or a sign-in that needs another factor
// (the full form). With nothing left, the browser goes to the authorize request for consent.
function SsoCallbackRoute() {
  const { redirect_url } = Route.useSearch();
  const navigate = useNavigate();
  const authorize = authorizeRequestFromSearch(redirect_url);
  const destination = authorize?.href ?? DEFAULT_POST_AUTH_REDIRECT;

  return (
    <main className="flex min-h-screen items-center justify-center bg-[#0d0d0f] px-4 py-10">
      <HandleSSOCallback
        navigateToApp={({ decorateUrl }) => {
          window.location.assign(decorateUrl(destination));
        }}
        navigateToSignIn={() => {
          void navigate({ to: "/login", search: { redirect_url, connect: "manual" } });
        }}
        navigateToSignUp={() => {
          void navigate({ to: "/login/complete", search: { redirect_url } });
        }}
      />
      <div id="clerk-captcha" />
      <p
        className="font-mono-hb text-[11px] uppercase tracking-[0.2em] text-[#8a8a8a]"
        aria-live="polite"
      >
        Signing you in…
      </p>
    </main>
  );
}
